// import Button from "../Button";
import React, { useCallback, useState } from "react";
import { formatDateUA, formatTimeOnly } from "../../helpers/formateDate";
import {
  Block,
  Details,
  Divider,
  Person,
  // ProcessIcon,
  GeneralBlock,
  InfobarBlock,
  StatusDoc,
  AccordionDetails,
  Accordion,
  AccordionSummary,
  AccordionStatusSign,
  CrossBtn,
} from "../../styles/View/Infobar/Infobar.styled";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { nameCompiler } from "../../helpers/nameCompiler";
import { Counterparties } from "./Counterparties";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import DocsToolbarDevice from "../Docs/DocsToolbarDevice";
import { ProcessSigningIcon, Remove } from "../../../public/icons/index";
import AttributesDoc, { AttributesMainDoc } from "../attributes/AttributesInfo";
import { AddAttributesDocPopup } from "../attributes/AddAttributesDocPopup";
import { Btn } from "../../styles/Button.styled";
import { AddSignersPopup } from "../attributes/AddSignerPopup";
import { ICompany, IDoc, IUser } from "../../interfaces/document";
import { getDocStatus } from "../../helpers/docStatus";
import {
  isDocSigning,
  isDocOwner,
  isDocUnsigned,
} from "../../helpers/docPermissions";
import { signerDocDelete } from "../../actions/signers";

interface InfoProps {
  doc: IDoc;
  sign?: any;
  signMethods?: Record<string, any>;
  clickCloseButton?: () => void;
  heightBar?: number;
  public?: boolean;
  publicSign?: boolean;
  general?: boolean;
}

interface InfoSignedProps {
  company: ICompany;
  signatures: any[];
  user: IUser | null;
  creator?: boolean;
  self?: boolean;
  signing?: boolean;
  docSigned?: boolean;
  canDeleteSigner?: (id: string) => void;
  cancelled?: boolean;
  cancelComment?: string;
}

export const RemoveBtn = ({
  user,
  canDelete,
  canDeleteSigner,
}: {
  user: any;
  canDelete: boolean;
  canDeleteSigner: (id: string) => void;
}) => {
  if (!canDelete) return null;
  return (
    <button
      type="button"
      onClick={() => canDeleteSigner(user?.id)}
      style={{
        background: "none",
        border: "none",
        cursor: "pointer",
        color: "var(--vivid-pink)",
      }}
    >
      <Remove />
    </button>
  );
};

const isPersonal = (company: ICompany) => !company?.code;

const SignerName = ({ user }: { user: any }) => (
  <>{nameCompiler(user) ?? user.email}</>
);

interface SignerDetailsProps {
  company: ICompany;
  signatures: any[];
  user: any | null;
  canDelete: boolean;
  onDelete: (id: string) => void;
  cancelled?: boolean;
  cancelComment?: string;
}

function SignerDetails({
  company,
  signatures,
  user,
  canDelete,
  onDelete,
  cancelled,
  cancelComment,
}: SignerDetailsProps) {
  if (isPersonal(company) && !user) return null;

  const status = signatures?.length > 0 ? "success" : "wait";
  const hasSignatures = signatures?.length > 0;

  return (
    <>
      {cancelled && cancelComment && (
        <div
          style={{
            color: "var(--dark-gray)",
            fontWeight: 600,
            fontSize: 12,
          }}
        >
          {cancelComment}
        </div>
      )}

      <span
        style={{
          display: "flex",
          gap: "16px",
          width: "100%",
          position: "relative",
        }}
      >
        <Person $status={status}>
          {isPersonal(company) ? (
            <>
              {user && (
                <li>
                  <SignerName user={user} />
                </li>
              )}
              <li>{user?.login}</li>
              <li>{user?.code}</li>
            </>
          ) : (
            <>
              <li>{company?.title}</li>
              <li>{company?.code}</li>
            </>
          )}
        </Person>
        <RemoveBtn
          user={user}
          canDelete={canDelete}
          canDeleteSigner={onDelete}
        />
      </span>

      {hasSignatures ? (
        <Details>
          <li>
            {formatDateUA(signatures[0].date)}&nbsp;&nbsp;
            <span style={{ color: "var(--dark-gray)" }}>
              {formatTimeOnly(String(signatures[0].date))}
            </span>
          </li>
          {user && (
            <li>
              <span style={{ color: "var(--dark-gray)" }}>
                Електронний підпис{" "}
              </span>
              <br />
              <SignerName user={user} />
            </li>
          )}
        </Details>
      ) : (
        !isPersonal(company) &&
        user && (
          <Details>
            <li>
              <SignerName user={user} />
            </li>
          </Details>
        )
      )}
    </>
  );
}

function InfoSigned(props: InfoSignedProps) {
  const canDelete = !props.self && !props.docSigned && !props.signing;

  const blockStatus = props.cancelled
    ? "cancelled"
    : props.signatures?.length > 0
      ? "success"
      : "wait";

  return (
    <Block $status={blockStatus}>
      {props.cancelled ? (
        <div>Скасований</div>
      ) : props.signatures?.length > 0 ? (
        <div>Підписаний</div>
      ) : (
        <div>
          {props.self || props.self === undefined
            ? "Очікує вашого підпису"
            : "Очікує підпису"}
        </div>
      )}

      <SignerDetails
        company={props.company}
        signatures={props.signatures}
        user={props.user}
        canDelete={canDelete}
        onDelete={props.canDeleteSigner ?? (() => undefined)}
        cancelled={props.cancelled}
        cancelComment={props.cancelComment}
      />
    </Block>
  );
}

export const StatusDocInfo: React.FC<{ doc: IDoc }> = ({ doc }) => {
  const user = useAppSelector((state) => state.user);
  if (!doc) return null;
  const { status, title } = getDocStatus(doc, user?.company);

  return <StatusDoc $status={status}>{title}</StatusDoc>;
};

export default function Infobar(props: InfoProps) {
  const user = useAppSelector((state) => state.user);
  const cancelDocState = useAppSelector((state: any) => state.cancelDoc);
  const [open, setOpen] = useState(false);
  const [attributePopup, setAttributePopup] = useState(false);
  const [attrHint, setAttrHint] = useState<string | undefined>();
  const [signersPopup, setSignersPopup] = useState(false);
  const dispatch = useAppDispatch();
  const isAbleToCancel =
    (user.id !== props.doc?.creator?.id &&
      (props.doc.signatures?.length ?? 0) === 0);

         console.log("creator",user.id, props.doc.creator?.id , (user.id === props.doc?.creator?.id ));
  //       (props.doc.counterparties ?? []).every((item) => !!item?.cancelled === true)));

  // console.log("creator i", isAbleToCancel )
  // const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleCloseAttribute = () => setAttributePopup(false);

  const canDeleteSigner = useCallback(
    (id: string) => {
      if (!id) return;
      dispatch(signerDocDelete(props.doc.id, id));
    },
    [dispatch, props.doc.id],
  );

  const CloseButton = () =>
    props.clickCloseButton ? (
      <CrossBtn
        onClick={(e) => {
          e.preventDefault();
          props.clickCloseButton?.();
        }}
      />
    ) : null;

  const GeneralInfo = (
    <GeneralBlock>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "1rem" }} />}
        >
          Загальна інформація
        </AccordionSummary>
        <AccordionDetails>
          <Divider $marginTop="0" />
          <div style={{ fontFamily: "Mulish" }}>
            <React.Fragment>
              <h5 style={{ marginTop: "10px" }}>{props.doc.title}</h5>

              <ul>
                {props.doc.type?.title && (
                  <li>
                    <div style={{ color: "var(--disabled-c)" }}>Тип:</div>
                    <span>{props.doc.type.title}</span>
                  </li>
                )}
                {props.doc.date && (
                  <li>
                    <div
                      style={{
                        color: "var(--disabled-c)",
                        paddingBottom: "5px",
                      }}
                    >
                      Створений:
                    </div>
                    {formatDateUA(props.doc.date)}
                    &nbsp;&nbsp;
                    <span style={{ color: "var(--dark-gray)" }}>
                      {formatTimeOnly(String(props.doc.date))}
                    </span>
                  </li>
                )}
                {props.doc.creator && (
                  <li>
                    <div
                      style={{
                        color: "var(--disabled-c)",
                        paddingBottom: "5px",
                      }}
                    >
                      Автор:
                    </div>
                    <span>{nameCompiler(props.doc.creator)}</span>
                  </li>
                )}
              </ul>
            </React.Fragment>
          </div>
        </AccordionDetails>
      </Accordion>
    </GeneralBlock>
  );

  if (props.public) {
    return (
      <InfobarBlock>
        <CloseButton />
        {GeneralInfo}
      </InfobarBlock>
    );
  }

  if (
    user.id === props.doc.creator?.id &&
    user.permissions["pub.docs.upload"]
  ) {
    return (
      <InfobarBlock>
        <CloseButton />
        {props.doc.signatures?.length > 0 && (
          <>
            <Accordion defaultExpanded id="calculated">
              <AccordionSummary
                expandIcon={
                  <ArrowForwardIosSharpIcon sx={{ fontSize: "1rem" }} />
                }
              >
                <p>Підписання</p>
                <StatusDocInfo doc={props.doc} />
              </AccordionSummary>
              <AccordionDetails>
                <DocsToolbarDevice
                  signMethods={props.signMethods}
                  sign={props.sign}
                  doc={props.doc}
                  isStamp={user.company?.stamp}
                />
              </AccordionDetails>
            </Accordion>
            <InfoSigned
              company={user.company}
              signatures={props.doc.signatures}
              user={user}
              creator={props.doc.creator?.id === user.id}
              signing={isDocSigning(props.doc)}
              docSigned={
                props.doc.signatures?.length > 0 ||
                props.doc.counterparties?.some(
                  (c: any) => c.signatures?.length > 0,
                )
              }
              canDeleteSigner={canDeleteSigner}
            />
          </>
        )}
      </InfobarBlock>
    );
  }

  const StatusSign = props.doc.cancelled ? (
    props.doc.comment && (
      <Block $status="cancelled">
        <div>
          {/* <CanceledIcon value="10"/> */}
          Причина скасування
        </div>
        <Person $status="cancelled">{props.doc.comment}</Person>
      </Block>
    )
  ) : props.doc.error ? (
    props.doc.error.code === 115 ? (
      <Block $status="loading">
        <div>
          <ProcessSigningIcon />
          Підписується...
        </div>
        {user && (
          <Person $status="loading">
            {user.company?.code === "" ? (
              <React.Fragment>
                <li>{nameCompiler(user)}</li>
                <li>{user.login}</li>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <li>{user.company?.title}</li>
                <li>{user.company?.code}</li>
              </React.Fragment>
            )}
          </Person>
        )}
      </Block>
    ) : (
      <Block $status="failure">
        <div>Помилка</div>
        <Person $status="failure">{props.doc.error.message}</Person>
      </Block>
    )
  ) : (
    <InfoSigned
      company={user.company}
      signatures={props.doc.signatures}
      user={user}
      creator={props.doc.creator?.id === user.id}
      self={true}
      signing={isDocSigning(props.doc)}
      docSigned={props.doc.signatures?.length > 0}
    />
  );

  return (
    <InfobarBlock id="section" heightBar={props.heightBar}>
      {props.clickCloseButton && (
        <CrossBtn
          onClick={(e) => {
            e.preventDefault();
            if (props.clickCloseButton) {
              props.clickCloseButton();
            }
          }}
        />
      )}

      <Accordion
        defaultExpanded
        id="calculated"
        // $calculated={calculated}
      >
        <AccordionSummary
          expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "1rem" }} />}
        >
          <p>Підписання</p>
          <StatusDocInfo doc={props.doc} />
        </AccordionSummary>
        {!props.doc.cancelled && (
          <AccordionDetails>
            <DocsToolbarDevice
              signMethods={props.signMethods}
              isStamp={user.company?.stamp}
              sign={props.sign}
              doc={props.doc}
              isAbleToCancel={isAbleToCancel}
              onOpenAttrPopup={(hint: string | undefined) => {
                setAttrHint(hint);
                setAttributePopup(true);
              }}
            />
            <AccordionStatusSign>
              <>
                <Divider $marginTop="0" />
                <p>Підпис вашої компанії</p>
              </>
              {StatusSign}
              {cancelDocState?.state === "failure" && (
                <Block $status="failure">
                  <div>Помилка скасування</div>
                  <Person $status="failure">
                    {cancelDocState?.message || "Не вдалося скасувати документ"}
                  </Person>
                </Block>
              )}
              {!!props.doc.counterparties?.length && (
                <>
                  <Divider />
                  <p>
                    Підписи{" "}
                    {props.doc.counterparties?.length > 1
                      ? "контрагентів"
                      : "контрагента"}{" "}
                  </p>
                </>
              )}
              {props.doc.counterparties?.map((counterparty: any, i: number) => (
                <InfoSigned
                  key={i}
                  company={counterparty.company}
                  signatures={counterparty.signatures}
                  user={counterparty.user}
                  cancelled={counterparty.cancelled}
                  cancelComment={counterparty.comment}
                  self={false}
                  creator={props.doc.creator?.id === user.id}
                  signing={isDocSigning(props.doc)}
                  docSigned={
                    props.doc.signatures?.length > 0 ||
                    props.doc.counterparties?.some(
                      (c: any) => c.signatures?.length > 0,
                    )
                  }
                  canDeleteSigner={canDeleteSigner}
                />
              ))}
              {/* {!props.doc.cancelled && props.doc.counterparties?.length > 10 && (
                <Button
                  type="button"
                  onClick={handleOpen}
                  title="Переглянути підписантів"
                  bgcolor="red"
                  $marginTop="10px"
                  $height="40px"
                  $width="100%"
                />
              )} */}
            </AccordionStatusSign>
          </AccordionDetails>
        )}
      </Accordion>

      {isDocOwner(props.doc, user.id) && isDocUnsigned(props.doc) && (
        <div style={{ height: 47 }}>
          <Btn
            type="button"
            $width="100%"
            $color="var(--white)"
            $marginTop="0"
            onClick={() => {
              setSignersPopup(true);
            }}
            $background="var(--cadetGrey)"
            $heightMobile="47px"
          >
            Додати контрагента
          </Btn>
        </div>
      )}

      <Accordion id="calculated">
        <AccordionSummary
          expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "1rem" }} />}
        >
          <p>Додаткові відомості</p>
        </AccordionSummary>
        <AccordionDetails>
          <AttributesMainDoc {...props.doc} />
          {props.doc?.attributes &&
            props.doc.attributes.length > 0 &&
            props.doc.attributes.map((item: any) => (
              <AttributesDoc key={item.id} {...item} />
            ))}
        </AccordionDetails>
      </Accordion>

      <Counterparties
        open={open}
        handleClose={handleClose}
        counterparties={props.doc.counterparties}
        signatures={props.doc.signatures}
      />
      {signersPopup && (
        <AddSignersPopup
          handleClose={() => setSignersPopup(false)}
          docId={props.doc.id}
          {...props.doc}
        />
      )}

      {attributePopup && (
        <AddAttributesDocPopup
          handleClose={() => {
            setAttrHint(undefined);
            handleCloseAttribute();
          }}
          hint={
            attrHint ??
            (!props.doc.type?.title ? "Виберіть тип документу" : undefined)
          }
          {...props.doc}
        />
      )}
    </InfobarBlock>
  );
}
